<h2>{{'main.perm.ask' | translate}}</h2>
<h2>{{'main.perm.ask.1' | translate}}</h2>

<div class="prem-holder mt-5">
  <div class="flex items-center justify-start prem-item pointer" (click)="location = !location">
    <mat-checkbox [(ngModel)]="location" (click)="$event.stopPropagation()"></mat-checkbox>
    <p class="ml-5">{{'main.perm.location' | translate}}</p>
  </div>

  <div class="flex items-center justify-start prem-item pointer" (click)="notification = !notification">
    <mat-checkbox [(ngModel)]="notification" (click)="$event.stopPropagation()"></mat-checkbox>
    <p class="ml-5">{{'main.perm.notif' | translate}}</p>
  </div>
</div>

<div class="flex items-center justify-between mt-5">

  <button class="btn" id="close" (click)="dialogRef.close()">{{'main.button.cancel' | translate}}</button>

  <button class="btn blue" [disabled]="!notification && !location" (click)="apply()">{{'main.button.apply' | translate}}</button>

</div>
